import React, {useEffect, useState} from 'react';
import Image from 'react-bootstrap/Image';

// redux
import { useSelector, useDispatch, } from 'react-redux';
import { selectAirportImage, getAirportImage, selectAirportImageStatus} from '../../../redux/slices/analytics/reviews';

// custom components
import { CustomSpinner } from '_atoms';

// styling
import {  Spacing } from '_styles';

const AirportImage = (props) => {

    // dispatch
    const dispatch = useDispatch();

    // redux vars
    const airportImage = useSelector(selectAirportImage);
    const status = useSelector(selectAirportImageStatus)

    // get airport image
    useEffect(() => {
        if (props.iata && airportImage == null || airportImage == undefined) {
            dispatch(getAirportImage(props.iata))        
        }
    }, [props.iata]);

    let height = props.height ? props.height : 200
    let width = props.width ? props.width : 200

    return (
        <>
        {
            status == 'loading' ? 
            <CustomSpinner/>
            :
            props.small ? 
            <Image
                src={airportImage != null ? airportImage : ''}
                height={35}
                width={35}
                style={{
                    borderRadius: 50,
                    marginTop: Spacing.SCALE_12,
                    marginBottom: Spacing.SCALE_12,
                    objectFit: 'cover', // Add this line
                }}
            />
            :
            <Image
                src={airportImage != null ? airportImage : ''}
                roundedCircle
                height={height}
                width={width}
                style={{ padding: Spacing.SCALE_12, objectFit: 'cover', borderRadius: '50%' }}
            />
        }
        </>
    );
};

export default AirportImage;
